import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Search } from 'lucide-react';
import Layout from '../components/layout/Layout';
import NewsCard from '../components/news/NewsCard';
import { NewsCardSkeleton } from '../components/news/Skeletons';
import { newsAPI } from '../services/api';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';

const SearchPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [query, setQuery] = useState(searchParams.get('q') || '');
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  useEffect(() => {
    const q = searchParams.get('q');
    if (q) {
      setQuery(q);
      performSearch(q);
    }
  }, [searchParams]);

  const performSearch = async (searchQuery) => {
    if (!searchQuery || searchQuery.length < 2) {
      setResults([]);
      return;
    }

    setLoading(true);
    setSearched(true);
    try {
      const response = await newsAPI.search(searchQuery);
      setResults(response.data);
    } catch (error) {
      console.error('Search error:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (query.trim()) {
      setSearchParams({ q: query.trim() });
    }
  };

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8" data-testid="search-page">
        {/* Search Header */}
        <div className="max-w-2xl mx-auto mb-12">
          <h1 className="text-3xl md:text-4xl font-extrabold text-[#0F172A] tracking-tight text-center mb-6">
            Haber Ara
          </h1>
          <form onSubmit={handleSubmit} className="flex gap-3">
            <div className="relative flex-1">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              <Input
                type="text"
                placeholder="Anahtar kelime girin..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="pl-12 h-12 text-base border-gray-200 focus:border-[#0284C7] focus:ring-[#0284C7]"
                data-testid="search-input"
              />
            </div>
            <Button type="submit" size="lg" className="px-8 bg-[#0F172A] hover:bg-[#1E293B]" data-testid="search-submit">
              Ara
            </Button>
          </form>
        </div>

        {/* Results */}
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <NewsCardSkeleton key={i} />
            ))}
          </div>
        ) : searched ? (
          <>
            <div className="mb-6">
              <p className="text-gray-600">
                <span className="font-semibold text-[#0F172A]">"{searchParams.get('q')}"</span> için{' '}
                <span className="font-semibold">{results.length}</span> sonuç bulundu
              </p>
            </div>
            {results.length === 0 ? (
              <div className="text-center py-16 bg-gray-50 rounded-lg">
                <p className="text-gray-500 text-lg mb-2">Aramanızla eşleşen haber bulunamadı.</p>
                <p className="text-gray-400 text-sm">Farklı anahtar kelimeler deneyin.</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-8">
                {results.map((news) => (
                  <NewsCard key={news.id} news={news} />
                ))}
              </div>
            )}
          </>
        ) : (
          <div className="text-center py-16">
            <p className="text-gray-400 text-lg">Aramak istediğiniz kelimeyi girin</p>
          </div>
        )}
      </div>
    </Layout>
  );
};

export default SearchPage;
